import { initPersonalInfoForm as initStoreLocator } from '@molecules/store-locator/store-locator.mjs';
import {
  initFindCivicAddressesForm
} from "../../20-molecules/store-locator/find-civic-addresses-form.mjs";

(function ($, Drupal, drupalSettings, once) {

  'use strict';

  const container = document.querySelector('.js-claimbyphone');

  // Exit on pages where the container does not exist.
  if (!container) return;

  /*
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   * Globally accessible API
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   */

  Promutuel.claimByPhone = {
    // Constants

    // Properties

    // Methods

    /**
     * Update UI components to match the given mutual ID.
     *
     * If parameters are not provided, their values will be computed from the current cookies.
     *
     * @param {Number}  [mutualId]
     * @param {Boolean} [ignoreOpeningHours] If true, the panel won't be hidden,
     *        even outside of the 08:30-16:30 time frame.
     */
    async personalizeUI(mutualId = Promutuel.mutuals?.getMyMutualId(), ignoreOpeningHours = false) {
      const mutual = Promutuel.mutuals?.getMutualSummary(mutualId);
      if (!mutual) return;

      const findMutual = container.querySelector('.js-claimbyphone-findmutual');
      const myMutual = container.querySelector('.js-claimbyphone-mymutual');

      // Hide form section, allowing transition.
      findMutual.classList.add('claimbyphone__section--hidden');
      findMutual.setAttribute('aria-hidden', true);

      // Show phone number section.
      myMutual.classList.remove('claimbyphone__section--hidden');
      myMutual.setAttribute('aria-hidden', false);
    },

  };

  /*
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   * Behaviors and event management
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   */

  Drupal.behaviors.promutuel_claimByPhone = {
    attach: function attach(context) {

      $(once('promutuelClaimByPhone', '.js-claimbyphone', context)).each(function () {

        const notfoundPanel = container.querySelector('.js-claimbyphone-mutualnotfound');

        // 'Back to form' button.
        container.querySelectorAll('.js-claimbyphone-back').forEach(node => {
          node.addEventListener('click', event => {
            event.preventDefault();
            notfoundPanel.classList.add('claimbyphone__movingpanel--hidden');
            notfoundPanel.setAttribute('aria-hidden', true);
            document.querySelector('.js-hide-no-mutual').classList.remove('d-none');
          });
        });

        initStoreLocator(container, {
          idPrefix: 'claimbyphone',
          addressCompleteKey: drupalSettings.addresscomplete_key,
          onsuccess: function (data, searchmode) {
            // Memorize cookie.
            Promutuel.mutuals.setMyMutual({ id: data.mutual, searchmode });

            Promutuel.claimByPhone.personalizeUI(data.mutual, /*ignoreOpeningHours =*/ true);
          },
          onfailure: function (err, searchmode) {
            console.log(err);
            notfoundPanel.classList.remove('claimbyphone__movingpanel--hidden');
            notfoundPanel.setAttribute('aria-hidden', false);

            document.querySelector('.js-hide-no-mutual').classList.add('d-none');
          },
        });
      });
    }
  };

  Drupal.behaviors.promutuel_claimByPhoneAddresses = {
    attach: function attach(context) {
      const container = document.querySelector('.js-claimbyphone-form');
      const submitBtn = container.querySelector('.js-claim-fcaddresses-submit');

      // Exit on pages where the container does not exist.
      if (!container) return;

      $(once('promutuelclaimByPhoneAddresse', container, context)).each(function () {

        const form = document.querySelector('.js-claim-fcaddresses-form');

        const onAddressesFound = function (data) {
          return data;
        };
        const onAddressesNotFound = function (err) {
          return err;
        };

        initFindCivicAddressesForm(container, {
          idPrefix: 'claim-fcaddresses',
          onsuccess: onAddressesFound,
          onfailure: onAddressesNotFound
        });
      });
    }
  };

})(jQuery, Drupal, drupalSettings, once);
